



































































































































































































import { defineComponent, reactive, SetupContext, toRef, toRefs, watch } from "@vue/composition-api";
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";

interface School {
  id?: number
  name: string;
  address: string;
  contact_address: string;
  counter_responsible: string;
  counter_mail_address: string;
  ip_address: string;
  school_url_prefix: string
  school_signature: string
  data_transfer_email: string
  option_no_4: boolean;
  option_no_9: boolean;
  option_no_10: boolean;
  option_no_11: boolean;
  option_no_12: boolean;
  option_no_13: boolean;
  option_no_14: boolean;
  option_no_15: boolean;
  option_no_16: boolean;
  option_no_17: boolean;
  option_no_18: boolean;
  option_no_19: boolean;
  option_no_20: boolean;
  option_no_21: boolean;
  option_no_22: boolean;
  option_no_23: boolean;
  option_no_24: boolean;
  option_no_25: boolean;
  option_no_26: boolean;
}

interface SchoolEditData {
  currentUser: any;
  url: string;
  school: School;
  errors: string[];
  school_id?: number;
  isCreate: boolean;
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context: SetupContext) {

    /******************************
     * data
     ******************************/

    const state = reactive<SchoolEditData>({
      currentUser: context.root.$store.state.currentUser,
      url: "",
      school: {
        id: null,
        name: "",
        address: "",
        contact_address: "",
        counter_responsible: "",
        counter_mail_address: "",
        ip_address: "",
        school_url_prefix: "",
        school_signature: "",
        data_transfer_email: "",
        option_no_4: false,
        option_no_9: false,
        option_no_10: false,
        option_no_11: false,
        option_no_12: false,
        option_no_13: false,
        option_no_14: false,
        option_no_15: false,
        option_no_16: false,
        option_no_17: true,
        option_no_18: true,
        option_no_19: true,
        option_no_20: false,
        option_no_21: false,
        option_no_22: false,
        option_no_23: false,
        option_no_24: false,
        option_no_25: false,
        option_no_26: false,
      },
      errors: [],
      school_id: context.root.$route.query.id ? parseInt(context.root.$route.query.id.toString()) : null,
      isCreate: context.root.$route.query.id ? false : true,
    });


    /******************************
     * methods
     ******************************/
    
    /**
     * 戻る処理
     */
    const goBack = (): void => {
        context.root.$router.go(-1);
    };

    /**
     * 学校登録処理
     */
    const createSchool = async (): Promise<void> => {

      if(!validate()){
        window.scroll({top: 0, behavior: 'smooth'});
        return;
      }

      if(!confirm(`学校情報を登録します。よろしいですか？`)){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.post(`/api/teacher/school_edit`, {school: state.school}).then(response => {
        alert(`登録処理が完了しました。`);
        goBack();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    const updateSchool = async ():Promise<void> => {

      if (!validate() || !confirm(`学校情報を更新します。よろしいですか？`)) {
        return;
      }

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.post(`/api/teacher/school_edit/update/${state.school_id}`, {school: state.school}).then(response => {
        alert(`更新処理が完了しました。`);
        goBack();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    } 

    /**
     * 入力チェック処理
     */
    const validate = (): boolean => {

      state.errors = [];

      if (!state.school.name) {
        state.errors.push("学校名は必須です。");
      }

      if (state.school.ip_address) {

        const regex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        const ipAddresses = state.school.ip_address.split(",");

        const formatErrorIpAddress = ipAddresses.filter(x => !regex.test(x));

        if (formatErrorIpAddress.length > 0) {
          state.errors.push("IPアドレスのフォーマットが違います。");
        }
      }

      if(!state.school.school_url_prefix){
        state.errors.push("生徒サイトURL接頭辞を入力してください。");
      }else if(state.school.school_url_prefix.includes(" ") || state.school.school_url_prefix.includes("　")){
        state.errors.push("生徒サイトURL接頭辞に空白は入力できません。");
      }else if(state.school.school_url_prefix.includes("/")){
        state.errors.push("生徒サイトURL接頭辞にスラッシュは入力できません。");
      }

      if(!state.school.option_no_9 && !state.school.option_no_10 && !state.school.option_no_11){
        state.errors.push("レポート・試験・講座のどれか1つはONにしてください。");
      }

      return state.errors.length == 0;
    }

    const targetUpdateSchool = async (): Promise<void> => {

      if (state.isCreate) {
        return;
      }

      context.root.$store.dispatch("showOverlay", `データ取得中... しばらくお待ちください。`);

      state.errors = [];
  
      await http.get(`/api/teacher/school_edit/${state.school_id}/edit`).then(response => {

        // 検索結果設定
        state.school = response.data.school;
        state.school.option_no_4 = response.data.option_no_4;
        state.school.option_no_9 = response.data.option_no_9;
        state.school.option_no_10 = response.data.option_no_10;
        state.school.option_no_11 = response.data.option_no_11;
        state.school.option_no_12 = response.data.option_no_12;
        state.school.option_no_13 = response.data.option_no_13;
        state.school.option_no_14 = response.data.option_no_14;
        state.school.option_no_15 = response.data.option_no_15;
        state.school.option_no_16 = response.data.option_no_16;
        state.school.option_no_17 = response.data.option_no_17;
        state.school.option_no_18 = response.data.option_no_18;
        state.school.option_no_19 = response.data.option_no_19;
        state.school.option_no_20 = response.data.option_no_20;
        state.school.option_no_21 = response.data.option_no_21;
        state.school.option_no_22 = response.data.option_no_22;
        state.school.option_no_23 = response.data.option_no_23;
        state.school.option_no_24 = response.data.option_no_24;
        state.school.option_no_25 = response.data.option_no_25;
        state.school.option_no_26 = response.data.option_no_26;
        state.url = response.data.url;
      })
      .catch(error => {

        if(error.response.status == 422){
          alert(`編集対象学校情報の取得処理に失敗しました。学校一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`編集対象学校情報の取得処理に失敗しました。学校一覧に戻ります。`);
        }

        goBack();
      });

      context.root.$store.dispatch("hideOverlay");
    }


    /******************************
     * created
     ******************************/

    targetUpdateSchool();


    /******************************
     * watch
     ******************************/


    return {
      ...toRefs(state),
      goBack,
      createSchool,
      updateSchool,
    };
  },
})
